export enum PermissionEnum {
	ARTICLE_VIEW_VISIBLE_ONLY = 'article.view.visible.only'
}
